// The blog posts written for the person taking the interview. They carry the
// Just One Interview practice CTAs (see candidateCta.ts).
// Blog categories written for the person taking the interview.
const CANDIDATE_BLOG_CATEGORIES = new Set([
  "AI Interview Prep",
  "Role Guides",
  "Data and Insights",
]);

// General-interest AI posts (Meta Muse, OpenAI dots, AI gadgets, decision
// models). They bring the blog's largest search traffic, and almost none of it
// is recruiters, so they carry the practice CTAs too (Deepak, 2026-10-24).
const GENERAL_INTEREST_BLOG_SLUGS = new Set([
  "meta-muse-vs-instinct",
  "meta-muse-charm",
  "how-openai-dots-work",
  "meta-muse-vs-openai-dots",
  "muse-charm-vs-openai-device",
  "jev-vs-llm-models",
  "what-is-openai-dots",
]);

/** A general-interest post: practice CTAs, with a callout that does not assume an interview topic. */
/** @param {string | undefined} slug */
export function isGeneralInterestPost(slug) {
  return !!slug && GENERAL_INTEREST_BLOG_SLUGS.has(slug);
}

// Comparison posts written from the candidate's side.
const CANDIDATE_BLOG_SLUGS = new Set([
  "ai-interviews-vs-phone-screens",
  "ai-interview-vs-one-way-video",
  // Filed under "For Recruiters", but its search traffic is candidates asking
  // what an AI telephonic round is (Deepak, 2026-10-13).
  "ai-phone-interview-guide",
]);

/** @param {{ slug?: string, category?: string } | null | undefined} post */
export function isCandidateBlogPost(post) {
  if (!post) return false;
  if (post.slug && (CANDIDATE_BLOG_SLUGS.has(post.slug) || GENERAL_INTEREST_BLOG_SLUGS.has(post.slug))) return true;
  return !!post.category && CANDIDATE_BLOG_CATEGORIES.has(post.category);
}
